<template>
  <div class="bg-purple-ap-100 h-screen w-screen">
    <div
      class="flex flex-col items-center h-full justify-center max-w-6xl m-auto px-4 sm:px-0"
    >
      <div
        class="flex rounded-lg shadow-lg w-full sm:w-3/4 lg:w-2/3 bg-white sm:mx-0"
      >
        <div
          class="flex flex-col justify-center items-center w-full lg:w-1/2 p-4"
        >
          <div class="w-full flex flex-col justify-around items-center mt-10">
            <h1
              class="text-4xl text-center font-thin font-sil text-purple-ap-100"
            >
              {{ title }}
            </h1>
            <div class="w-full">
              <slot />
            </div>
          </div>
        </div>
        <div class="hero hidden md:block lg:w-1/2 rounded-r-lg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  props: ["title"],
};
</script>

<style scoped>
.hero {
  background: url("../../assets/img/hero.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
